import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=4e165437&scoped=true"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocuments.vue?vue&type=style&index=0&id=4e165437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e165437",
  null
  
)

export default component.exports